var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-btn",on:{"click":_vm.onBackClick}},[_c('i',{staticClass:"el-icon-back"})])
}
var staticRenderFns = []

export { render, staticRenderFns }